import { InjectionToken } from '@angular/core';
import { IotAuthProvider } from './models/auth-provider.enum';

export interface AuthConfig {
  ssoDisabled: boolean;
  appName?: string;
  rememberMe?: boolean;
  /** Identity provider; omitted ⇒ `IotAuthProvider.COGNITO`. */
  provider?: IotAuthProvider;
}

export const AUTH_CONFIG = new InjectionToken<AuthConfig>('AUTH_CONFIG');
